import React, { useState, useEffect, useRef } from "react";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminCheckBox from "../../../components/CommonComponents/AdminCheckBox";
import MessageBox from "../../../components/CommonComponents/MessageBox";

function RoleCreate(props) {
    const { id } = useParams()
    const navigate = useNavigate();
    const headers = getItemToken('access_token')
    const labelSource = 'roles-and-permission'

    const baseURL = process.env.REACT_APP_Baseurl
    const storeApi = `${baseURL}/admin/user-permission/store`
    const editApi = `${baseURL}/admin/user-permission/edit`
    const updateApi = `${baseURL}/admin/user-permission/update`
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`

    const combinedRef = useRef({
        role_name: null,
    });

    const [formData, setFormData] = useState({
        state: "formData",
        role_name: "",
        role_type: "",
        user_permission: []
    })
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false);
    const [formDataError, setFormDataError] = useState({})
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
        roleTypeOption: []
    })

    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'text' || type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    }
    const handleCheckboxChange = (id) => {
        setFormDataError((prev) => ({
            ...prev,
            ['permission_type']: ""
        }))
        if (id == 27) {
            toast.info("Default permission for library")
            return
        }
        const updatedPermissions = formData?.user_permission || [];
        const permissionIndex = updatedPermissions.findIndex(permission => permission.menu_id === id);

        if (permissionIndex !== -1) {
            setFormData((prev) => ({
                ...prev,
                user_permission: updatedPermissions.filter(permission => permission.menu_id !== id)
            }));
        } else {
            let access = formData?.access_type == "ALL" ? [1, 2, 3, 4] : formData?.access_type == "READ" ? [1] : []
            setFormData((prev) => ({
                ...prev,
                user_permission: [
                    ...updatedPermissions,
                    { menu_id: id, access: access }
                ]
            }));
        }
    };

    const handleAccessChange = (id, value) => {
        if (id == 27) {
            toast.info("Default permission for library")
            return
        }
        const updatedPermissions = formData?.user_permission || [];
        const permissionIndex = updatedPermissions.findIndex(permission => permission.menu_id === id);

        if (permissionIndex !== -1) {
            const updatedPermission = [...updatedPermissions];
            const currentAccess = updatedPermissions[permissionIndex].access || [];
            if (currentAccess.includes(value)) {
                updatedPermission[permissionIndex] = {
                    menu_id: id,
                    access: currentAccess.filter(accessValue => accessValue !== value),
                };
            } else {
                updatedPermission[permissionIndex] = {
                    menu_id: id,
                    access: [...currentAccess, value],
                };
            }
            setFormData((prev) => ({
                ...prev,
                user_permission: updatedPermission,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                user_permission: [
                    ...updatedPermissions,
                    { menu_id: id, access: [value] },
                ]
            }));
        }
    };

    const formValidation = () => {
        let formIsValid = true;
        if (formData?.user_permission?.length <= 0 && formData?.access_type && formData?.role_type) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                permission_type: "At least choose one of the permissions; it cannot be empty.",
            }));
            formIsValid = false;
        }
        if (!formData?.access_type) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                access_type: "access type cannot be empty.",
            }));
            combinedRef.current['access_type'].focus()
            formIsValid = false;
        }
        if (!formData?.role_type) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                role_type: "role type cannot be empty.",
            }));
            combinedRef.current['role_type'].focus()
            formIsValid = false;
        }
        if (!formData?.role_name) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                role_name: "Role name cannot be empty.",
            }));
            combinedRef.current['role_name'].focus();
            formIsValid = false;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.role_name)) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                role_name: "Role name should contain only letters.",
            }));
            combinedRef.current['role_name'].focus();
            formIsValid = false;
        }

        return formIsValid
    }

    const labelFetch = async () => {
        try {
            setShowOverlay(true)
            const response = await axios.get(`${labelApi}`, { headers: headers });
            const result = response?.data?.label_management
            setLabelDisplay(result)
            setShowOverlay(false)
        }
        catch (err) {
            setShowOverlay(false)
            toast.error(err?.response?.data?.message)

        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["role_name", "role_type", "access_type", "user_permission"])
                    formDataAdd[key] = formData[key]
            }

            const response = await axios.post(`${storeApi}`, formDataAdd, { headers: headers });
            const result = response?.data;
            if (result?.status) {
                setShowOverlay(false);
                toast.success(result?.message)
                navigate("/role-index");
            }
        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }

    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["role_name", "role_type", "access_type"])
                    formDataAdd[key] = formData[key]
            }
            formDataAdd.user_permission = await formData?.user_permission?.filter(item => item?.access?.length !== 0)

            const response = await axios.post(`${updateApi}/${id}`, formDataAdd, { headers: headers });
            const result = response?.data;
            if (result?.status) {
                toast.success(result?.message)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setWithOutRefresh(prev => !prev)
            setShowOverlay(false);
        }
    }

    const handleStore = (e) => {
        e.preventDefault()
        if (!id) {
            if (formValidation()) {
                handleAdd()
            }
            else {
                console.table("validation")
            }
        }
        else {
            if (formValidation()) {
                handleUpdate()
            }
            else {
                console.table("validation")
            }
        }
    }

    const fetchPermissions = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Baseurl}/admin/user-permission/create`,
                { headers: headers }
            );
            const result = response?.data
            setDefaultOption((prev) => ({
                ...prev,
                roleTypeOption: result?.role_type,
                permissionOption: result?.managements,
                accessTypeOption: result?.access_type,
            }))
        } catch (error) {
            console.error("Error fetching permissions:", error);
        }
    };

    const fetchData = async () => {
        setShowOverlay(true)
        try {
            const response = await axios.get(`${editApi}/${id}`, { headers: headers });
            const result = response?.data;
            setFormData(result?.data)
            const defaultoptionslist = {
                roleTypeOption: result?.role_type,
                permissionOption: result?.managements,
                accessTypeOption: result?.access_type,
            }
            setDefaultOption(defaultoptionslist);
            setShowOverlay(false)
        } catch (error) {
            setShowOverlay(false)
            if (error.response.status == 404) {
                setFormData({ error: error.response.data.message })
            }
        }
    };

    useEffect(() => {
        labelFetch()
    }, [])

    useEffect(() => {
        if (formData?.role_type) {
            const updatedPermissions = [...formData.user_permission];
            const existingPermission = updatedPermissions.find(permission => permission.menu_id === 27);
            if (!existingPermission) {
                updatedPermissions.push({ access: [1, 2, 3, 4], menu_id: 27 });
            } else if (existingPermission.access.length < 4) {
                existingPermission.access = [1, 2, 3, 4];
            }
            if (formData?.access_type == "ALL") {
                updatedPermissions.filter(item => item.menu_id !== 27).map((item) => item.access = [1, 2, 3, 4])
            }
            if (formData?.access_type == "READ") {
                updatedPermissions.filter(item => item.menu_id !== 27).map((item) => item.access = [1])
            }
            setFormData((prev) => ({
                ...prev,
                user_permission: updatedPermissions
            }));

        }
    }, [formData?.access_type]);



    useEffect(() => {
        if (id) {
            fetchData()
        }
        else {
            fetchPermissions();
        }
    }, [withOutRefresh]);

    return (
        <>
            <AdminBackNavigation path="/role-index" text="Back" />
            {showOverlay && <Response_Processing />}
            <div className="">
                <AdminSaveHeader heading={!id ? labelDisplay?.[1]?.title : labelDisplay?.[1]?.sub_title} saveText={!id ? labelDisplay?.[7]?.title : labelDisplay?.[7]?.sub_title} saveMethod={handleStore} />
                <FormContainer>
                    <LeftWrapper>
                        <Wrapper>
                            <MessageHeading text={!id ? labelDisplay?.[2]?.title : labelDisplay?.[2]?.title} />
                            <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                            <AdminCustomInput type="text" name="role_name" value={formData?.role_name} onChange={handleInput} placeHolder={"Role name"} ref={(el) => (combinedRef.current.role_name = el)} error={formDataError?.role_name} />
                            <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
                            <AdminCustomSelect name="role_type" error={formDataError?.role_type} value={formData?.role_type} onChange={handleInput} ref={(el) => (combinedRef.current.role_type = el)} options={defaultOption?.roleTypeOption?.map((item, index) => ({ name: item?.name, value: item?.type }))} defaultOptionName={"Choose an role type"} />
                            <MessageLabel text={labelDisplay?.[5]?.title} className="mandatorySimple" />
                            <AdminCustomSelect name="access_type" error={formDataError?.access_type} value={formData?.access_type} onChange={handleInput} ref={(el) => (combinedRef.current.access_type = el)}
                                options={
                                    formData?.role_type === "partner"
                                        ? (defaultOption?.accessTypeOption?.filter(item => item.type === "CUSTOM")?.map((item) => ({
                                            name: item?.name,
                                            value: item?.type
                                        })))
                                        : defaultOption?.accessTypeOption?.map((item) => ({
                                            name: item?.name,
                                            value: item?.type
                                        }))
                                } defaultOptionName={"Choose an access type"} />
                        </Wrapper>
                    </LeftWrapper>
                    <RightWrapper>
                        <Wrapper>
                            <MessageHeading text={labelDisplay?.[6]?.title} className="mandatorySimple" />
                            {formDataError?.permission_type ? <MessageBox text={`${formDataError?.permission_type}`} classname='errorred mb-2 d-block' /> : ""}
                            {formData?.access_type !== "" && formData?.access_type == "CUSTOM" ? <>
                                <div className="d-flex align-items-center mb-2 flex-wrap" >
                                    <div className="col-7">
                                        <div className="">
                                            <MessageLabel text={"Menu"} />
                                        </div>
                                    </div>
                                    <div className="col-5 d-flex align-items-center justify-content-between">
                                        <div className="align-self-center d-flex justify-content-center">
                                            <MessageLabel text={"Read"} />
                                        </div>
                                        <div className=" align-self-center d-flex justify-content-center">
                                            <MessageLabel text={"Add"} />
                                        </div>
                                        <div className=" align-self-center d-flex justify-content-center">
                                            <MessageLabel text={"Update"} />
                                        </div>
                                        <div className=" align-self-center d-flex justify-content-end">
                                            <MessageLabel text={"Delete"} />
                                        </div>
                                    </div>
                                </div>
                            </> : ""}
                            {
                                formData?.role_type && formData?.access_type && !showOverlay ? defaultOption?.permissionOption?.length && defaultOption?.permissionOption
                                    .filter((item) => {
                                        if (formData?.role_type === "partner") {
                                            return [3, 4, 5, 6, 7, 27, 30, 31, 32, 33, 34].includes(item?.id);
                                        }
                                        return true;
                                    })
                                    .map((item) => {
                                        const isChecked = formData?.user_permission?.some(permission => permission?.menu_id == item?.id);
                                        const isCheckedAccess = formData?.user_permission?.find(permission => permission?.menu_id == item?.id)?.access || [];
                                        return (

                                            <div className="d-flex align-items-start mb-2 flex-wrap" key={item.id}>
                                                <div className={`${formData?.access_type == "CUSTOM" ? "col-7" : "col-7"}`}>
                                                    <MessageLabel text={item?.name} />
                                                </div>
                                                {formData?.access_type == "CUSTOM" ? <div className="col-5 d-flex align-items-center justify-content-between">
                                                    <div className="align-self-center d-flex justify-content-center">
                                                        <AdminCheckBox name={'read'} checked={isCheckedAccess?.includes(1)} onChange={() => handleAccessChange(item.id, 1)} />
                                                    </div>
                                                    <div className="align-self-center d-flex justify-content-center">
                                                        <AdminCheckBox name={'add'} checked={isCheckedAccess?.includes(2)} onChange={() => handleAccessChange(item.id, 2)} />
                                                    </div>
                                                    <div className="align-self-center d-flex justify-content-center">
                                                        <AdminCheckBox name={'update'} checked={isCheckedAccess?.includes(3)} onChange={() => handleAccessChange(item.id, 3)} />
                                                    </div>
                                                    <div className=" align-self-center d-flex justify-content-center">
                                                        <AdminCheckBox name={'delete'} checked={isCheckedAccess?.includes(4)} onChange={() => handleAccessChange(item.id, 4)} />
                                                    </div>

                                                </div> : ""
                                                }
                                                {formData?.access_type !== "CUSTOM" ? <div className={`${formData?.access_type == "CUSTOM" ? "col-5" : "col-5"} text-end`}>
                                                    <AdminSwitch name={'access_type'} checked={isChecked} onChange={() => handleCheckboxChange(item.id)} />
                                                </div> : ""}
                                            </div>)
                                    })
                                    : <MessageLabel text={labelDisplay?.[4]?.title} />}
                        </Wrapper>
                    </RightWrapper>
                </FormContainer>
            </div >
        </>
    );
}

export default RoleCreate;
